import {Link} from '@remix-run/react';
import {PublicationFile} from '../PublicationFile';

export interface BookChapterPublicationListItemProps {
  publication: Research.PublicPublicationDto;
}

export function BookChapterPublicationListItem({publication}: BookChapterPublicationListItemProps) {
  const metadata = [
    publication.language ? publication.language : undefined,
    publication.pageStart && publication.pageEnd
      ? `p${publication.pageStart}-${publication.pageEnd}`
      : undefined,
    publication.publishingCompany && publication.publishingCity
      ? `${publication.publishingCompany}, ${publication.publishingCity}`
      : undefined,
    publication.publishingCompany && !publication.publishingCity
      ? publication.publishingCompany
      : undefined,
    publication.isbn ? `(ISBN ${publication.isbn})` : undefined,
    publication.year,
    publication.doi ? publication.doi : undefined,
  ]
    .filter(Boolean)
    .join(' - ');

  const Markup = (
    <div className="px-2 py-2 flex flex-col w-full">
      {publication.bookTitle && (
        <span className="text-xs font-semibold text-shade-12">{publication.bookTitle}</span>
      )}
      <span className="font-semibold text-primary-12">{publication.title}</span>
      <span>{publication.authors}</span>
      <div className="flex gap-2 text-shade-11 text-sm items-center mb-1.5">{metadata}</div>
    </div>
  );

  return (
    <li className="bg-shade-2 rounded overflow-hidden">
      {publication.url ? (
        <Link to={publication.url}>
          <div className="hover:bg-shade-3 w-full">{Markup}</div>
        </Link>
      ) : (
        Markup
      )}
      {publication.file && <PublicationFile file={publication.file} />}
    </li>
  );
}
